import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UsersService } from '../../../../services/crud/users.service';
import { FormBuilder} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { PHONE_MASK } from '../../../../helpers/format-helpers';
import { AppUser } from '../../../../dto/app-user';
import { Company } from '../../../../dto/company';
import { CompanyService } from '../../../services/company.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  user: AppUser;
  roles: string[];
  companies: Company[];
  phoneMask = PHONE_MASK;

  @ViewChild('rolesInput', { static: false }) rolesInput: ElementRef;

  constructor(
    private snackBar: MatSnackBar,
    private appUserService: UsersService,
    private companiesService: CompanyService,
    private location: Location,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.appUserService.getRoles().subscribe(roles => {
      this.roles = roles;
      const id = this.route.snapshot.paramMap.get('id');
      if (id == 'new') {
        this.user = {roles: [], active: true} as AppUser;

      } else {
        this.appUserService.get( id ).subscribe( user => {
          if ( user.companyId == null ) {
 user.companyId = 0; 
}
          this.user = user;

        });
      }
    });
    this.companiesService.getAll().subscribe(companies => {
      this.companies = companies.data;
    });
  }

  onSubmit() {

    if (this.user.roleGroup == 'partner' && (this.user.companyId == null || this.user.companyId == 0 )) {
      this.showMessage('A partner user should be linked to his company.');
      return;
    }

    if (this.user.id == null) {
      this.appUserService.add(this.user)
        .subscribe(() => this.returnBack());
    } else {
      this.appUserService.update(this.user.id, this.user)
        .subscribe(() => this.returnBack());
    }
  }

  showMessage( message ) {
    this.snackBar.open( message, null, {
      duration: 5000,
      panelClass: [ 'app-mat-snack-bar' ]
    } );
  }

  returnBack() {
    this.location.back();
  }

  onRoleGroupChange(newValue) {
    if (newValue !== 'partner') {
      this.user.companyId = 0;
    }
  }
}
